import { createInjectionKey as o } from "../../_utils/vue/create-injection-key.js";
const e = o("n-dropdown-menu"), d = o("n-dropdown"), t = o("n-dropdown-option");
export {
  d as dropdownInjectionKey,
  e as dropdownMenuInjectionKey,
  t as dropdownOptionInjectionKey
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/dropdown/src/context.js
// module id = 318
// module chunks = 41